import { Action, createReducer, on } from '@ngrx/store';
import * as DataActions from './data.actions';

export const dataFeatureKey = 'signup';

export interface State {
  user: any;
  coupon: any;
  invoices: any;

  userError: any;
  addInfoError: any;
  vereficationOrgError: any;
  couponError: any;
}

export const initialState: State = {
  user: null,
  coupon: null,
  invoices: null,

  userError: null,
  addInfoError: null,
  vereficationOrgError: null,
  couponError: null
};

export const reducer = createReducer(
  initialState,

  on(DataActions.SignUp, state => state),
  on(DataActions.SignUpSuccess, (state, action) => state),
  on(DataActions.SignUpFailure, (state, { error: userError }) => {
    return { ...state, userError };
  }),

  on(DataActions.InitiateVerifyEmail, state => state),
  on(DataActions.InitiateVerifyEmailSuccess, (state, action) => state),
  on(DataActions.InitiateVerifyEmailFailure, (state, action) => state),

  on(DataActions.ChangeEMail, state => {
    return { ...state, userError: false };
  }),
  on(DataActions.ChangeEMailSuccess, (state, action) => {
    return { ...state, userError: null };
  }),
  on(DataActions.ChangeEMailFailure, (state, { error: userError }) => {
    return { ...state, userError };
  }),

  on(DataActions.ContactUs, state => {
    return { ...state, userError: false };
  }),
  on(DataActions.ContactUsSuccess, (state, action) => {
    return { ...state, userError: null };
  }),
  on(DataActions.ContactUsFailure, (state, { error: userError }) => {
    return { ...state, userError };
  }),

  on(DataActions.LoadUser, state => state),
  on(DataActions.LoadUserSuccess, (state, { data: user }) => {
    return { ...state, user };
  }),
  on(DataActions.LoadUserFailure, (state, action) => state),

  on(DataActions.AddInfo, state => state),
  on(DataActions.AddInfoSuccess, (state, action) => state),
  on(DataActions.AddInfoFailure, (state, { error: addInfoError }) => {
    return { ...state, addInfoError };
  }),

  on(DataActions.VerificateOrg, state => state),
  on(DataActions.VerificateOrgSuccess, (state, action) => state),
  on(DataActions.VerificateOrgFailure, (state, { error: vereficationOrgError }) => {
    return { ...state, vereficationOrgError };
  }),

  on(DataActions.RedeemCoupon, state => state),
  on(DataActions.RedeemCouponSuccess, (state, { data: coupon }) => {
    return { ...state, coupon };
  }),
  on(DataActions.RedeemCouponFailure, (state, { error: couponError }) => {
    return { ...state, couponError };
  }),

  on(DataActions.GetInvoicesDue, state => state),
  on(DataActions.GetInvoicesDueSuccess, (state, { data: invoices }) => {
    return { ...state, invoices };
  }),
  on(DataActions.GetInvoicesDueFailure, (state) => state)

);
